import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';

export interface IDropdownSelect {
  label: string;
  value: any;
  metaData?: any;
  count?: any;
  disabled?: boolean;
  sortName?: string;
}

@Component({
  selector: 'app-dropdown-control',
  standalone: true,
  imports: [DropdownModule, ReactiveFormsModule],
  templateUrl: './dropdown-control.component.html',
  styleUrl: './dropdown-control.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownControlComponent implements OnInit, OnChanges {
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() control!: FormControl | any;
  @Input() name: string = '';
  @Input() lightMode!: boolean;
  @Input() showClear: boolean = false;

  @Input() disabled!: boolean;
  @Input() loading: boolean = false;
  @Input() sm: boolean = false;
  @Input() options: IDropdownSelect[] = [];
  @Input() classess!: string;
  @Input() optionsSearchEnabled: boolean = false;
  @Input() additionalActionLabel!: string;
  @Input() additionalActionIconName!: string;

  @Input() optionsOverflowEllipsis: boolean;
  @Input() optionMultiLines: boolean;

  @Input() appendTo: string | undefined;

  @Output() triggerActionEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() triggerAfterClearEvent: EventEmitter<any> = new EventEmitter<any>();

  public immutableOptions!: IDropdownSelect[];

  constructor(private cdr: ChangeDetectorRef) {}
  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('options' in changes) {
      this.immutableOptions = [];
      this.immutableOptions = [...this.options];
      if (this.additionalActionLabel) {
        this.immutableOptions.push({
          label: this.additionalActionLabel,
          value: this.additionalActionLabel,
        });
      }
      this.cdr.markForCheck();
    }
  }

  public triggerAfterClearAction(event: any) {
    this.triggerAfterClearEvent.emit();
    this.cdr.markForCheck();
  }

  public triggerAction(event: any) {
    if (this.control.value == this.additionalActionLabel) {
      this.triggerActionEvent.emit();
      this.cdr.markForCheck();
    } else {
      // do nothing
    }
  }
}
